/*@flow*/
import gql from 'graphql-tag';

import type { DocumentNode } from 'graphql';
export default (gql(`
  query getButtons {
    me {
      id
      company {
        id
        googleFormButtons {
          id
          name
          url
          urlTemplate
          resourceName
          fields
          showOnResourcePage
        }
      }
    }
  }
`): DocumentNode);
